import { Pipe, PipeTransform } from '@angular/core';

import { environment } from '../../../environments/environment';

@Pipe({
  name: 'price'
})
export class PricePipe implements PipeTransform {


  constructor() {
  }

  transform(value: any, args?: any): any {
    if (value === undefined || value === null || value === '') {
      return '';
    }

    // FIXME get from args
    let fractionSize;

    if (typeof fractionSize === 'undefined' || fractionSize === null) {
      fractionSize = 0;
    }

    const formatted = Intl.NumberFormat(
      environment.locale,
      {
        style: 'currency',
        currency: environment.currencyCode,
        minimumFractionDigits: fractionSize,
        maximumFractionDigits: fractionSize
      }).format(value);

    return formatted;
  }

}
